export default __webpack_public_path__ + "static/media/3097.1a1eb4f3.jpg";